import { Button } from '@material-ui/core'
import React, { useState } from 'react'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { PDFViewBox } from './styles'

export default function PDFView({ url, nameFile }) {
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages)
    }

    const handleDownloadPdf = (base64, nomeArquivo) => {
        let a = document.createElement("a")
        a.href = `data:application/pdf;base64,${base64}`
        a.download = nomeArquivo
        a.click()
    }

    return (
        <PDFViewBox id="PDFViewBox">
            <PDFViewBox.Header id="PDFViewBox_Header">
                <PDFViewBox.HeaderLeft id="PDFViewBox_HeaderLeft"></PDFViewBox.HeaderLeft>
                <PDFViewBox.HeaderCenter id="PDFViewBox_HeaderCenter">
                    <Button
                        className="btn-pdf-nav"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <ChevronLeftIcon />
                    </Button>
                    <PDFViewBox.PageNumbers className="pdf-viewer-page-numbers">
                        Página {pageNumber} de {numPages}
                    </PDFViewBox.PageNumbers>
                    <Button
                        className="btn-pdf-nav"
                        disabled={pageNumber === numPages}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <ChevronRightIcon />
                    </Button>
                </PDFViewBox.HeaderCenter>
                <PDFViewBox.HeaderRight id="PDFViewBox_HeaderRight">
                    <Button
                        className="btn-download-pdf-view"
                        onClick={() => handleDownloadPdf(url, nameFile)}
                    >
                        <GetAppOutlinedIcon />
                    </Button>
                </PDFViewBox.HeaderRight>
            </PDFViewBox.Header>
            <PDFViewBox.Document id="PDFViewBox_Document">
                <PDFViewBox.DocumentContent id="PDFViewBox_DocumentContent">
                    <Document
                        file={`data:application/pdf;base64,${url}`}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        <Page pageNumber={pageNumber} />
                    </Document>
                </PDFViewBox.DocumentContent>
            </PDFViewBox.Document>
        </PDFViewBox>
    )
}